import React from "react";
import { ExternalLink } from "lucide-react";
import { arteVideo } from "../config/siteConfig";

/**
 * Section vidéo Arte (accueil).
 *
 * Le code d'intégration officiel Arte (iframe) est utilisé tel quel, dans un
 * conteneur responsive 16/9. Le lecteur Arte embarqué n'a pas de paramètre de
 * temps de départ documenté (pas de lecture automatique à 2:52 possible) :
 * on affiche donc juste en dessous une mention indiquant que l'extrait qui
 * nous intéresse commence à 2:52, avec un lien vers la vidéo sur arte.tv.
 *
 * Toutes les constantes (URL d'intégration, lien arte.tv, temps de départ)
 * sont centralisées dans src/config/siteConfig.js pour rester faciles à
 * modifier ou à retirer le jour où la vidéo n'est plus disponible sur Arte.
 */
const ArteVideoSection = () => {
  return (
    <section className="py-20 px-4 bg-[#FDFBF5]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-display text-4xl font-semibold text-[#21167D] mb-4">
          {arteVideo.sectionTitle}
        </h2>
        <p className="font-accent italic text-lg text-[#4A4458] mb-10">
          Un extrait diffusé sur Arte, à propos de la psychothérapie
        </p>

        <div
          className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-xl"
          style={{ aspectRatio: "16 / 9" }}
        >
          <iframe
            title={arteVideo.iframeTitle}
            src={arteVideo.embedUrl}
            allow="autoplay; fullscreen"
            allowFullScreen
            loading="lazy"
            style={{
              border: "none",
              width: "100%",
              height: "100%",
              position: "absolute",
              inset: 0,
              display: "block",
              backgroundColor: "#000000",
            }}
          />
        </div>

        <p className="mt-6 text-[#4A4458]">
          ▶ L'extrait qui me concerne commence à {arteVideo.startLabel}.{" "}
          <a
            href={arteVideo.pageUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 font-semibold text-[#21167D] underline underline-offset-4 hover:no-underline"
          >
            Voir sur arte.tv
            <ExternalLink className="w-4 h-4" />
          </a>
        </p>
      </div>
    </section>
  );
};

export default ArteVideoSection;
